const ROUTES_CONFIGS = {
    LOGO_URL: 1,
    COMPANY_NAME: 4,
    FIRST_HOUR: 5,
    GEO_INTERMEDIATE: 7,
    SPEED_MAX: 8,
    COST_PASAJE: 9,
    BLOCK_CHANGE_SALIDAS: 10,
    ALIAS_ROUTE: 11,
    HOUR_SHOW: 12,
    COST_ADMINISTRATIVE: 13,
    COST_GASOLINE: 14,
    TITLE_REPORT: 18,
    MINUTES_TO_EDIT: 22,
    MINUTES_TO_DELETE: 23,
    NON_ATTENDANCE_DAYS: 24,
    LOGO_FILE: 26,
    EMAIL_ADMIN: 27,
    //FONT_SIZE_PAPELETA_HORIZONTAL: 28,
    //FONT_SIZE_PAPELETA_VERTICAL: 29,
    NOTIFICATION_DAILY_SUMMARY_REPORT: 30,
    NOTIFICATION_PASAJE_DAILY_SUMMARY_REPORT: 31,
    MINUTES_PASAJE_BEFORE_START: 32,
    MINUTES_PASAJE_AFTER_END: 33,
    NOTIFICATION_DAILY_SUMMARY_REPORT_TIME: 34,
}

export {
    ROUTES_CONFIGS
};
